import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <Section emoji="🎁" eyebrow="Exclusive bonuses" title="5 Bonuses included free" subtitle="Valued at $275 — yours at no extra cost today." className="bg-cream" data-id="element-50" data-mp="pm2eu58fzvl9">
      <div className="space-y-4" data-id="element-51" data-mp="fs3ffdzr6px0">
        {bonuses.map(bonus => <article key={bonus.number} className="overflow-hidden rounded-3xl border border-navy/8 bg-white shadow-sm" data-id="element-52" data-mp="1stww7o2rjpv">
            {bonus.image && <div className="bg-navy-900 px-3 py-4 sm:px-6 sm:py-6" data-id="element-53" data-mp="3o2mzfloclidb">
                <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="mx-auto block w-full max-w-[420px] drop-shadow-2xl" loading="lazy" data-id="element-54" data-mp="3t06euows816u" />
              </div>}
            <div className="p-4 sm:p-5" data-id="element-55" data-mp="1r6z31pgdo1pp">
              <div className="flex flex-wrap items-center gap-2" data-id="element-56" data-mp="3idmx9swgczdy">
                <span className="rounded-full bg-teal-600 px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-white" data-id="element-57" data-mp="3dfd0jdv2xqq8">
                  🎁 Bonus #{bonus.number}
                </span>
                <span className="rounded-full bg-amber-100 px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-amber-800" data-id="element-58" data-mp="3n54y8gyh6zyx">
                  <s className="opacity-60" data-id="element-59" data-mp="2zglqc2jc8p7d">{bonus.price}</s> — FREE
                </span>
              </div>
              <h3 className="mt-3 font-display text-lg font-black leading-tight text-navy sm:text-xl" data-id="element-60" data-mp="2uhsm70pxyajv">
                {bonus.title}
              </h3>
              <p className="mt-2 text-[14px] leading-snug text-navy/70 sm:text-[15px]" data-id="element-61" data-mp="33h5qzg34eay9">
                {bonus.body}
              </p>
              <p className="mt-3 border-l-4 border-teal-500 bg-teal-50/70 py-2 pl-3 text-[13.5px] font-semibold leading-snug text-teal-800 sm:text-sm" data-id="element-62" data-mp="np00ivstwib8">
                {bonus.outcome}
              </p>
            </div>
          </article>)}
      </div>

      <div className="mx-auto mt-8 max-w-md" data-id="element-63" data-mp="3hhzkxdzjo3bt">
        <CTAButton label="Claim the 5 bonuses free" sublabel="$275 in bonuses included today" data-id="element-64" data-mp="3hgogrd26stk6" />
      </div>
    </Section>;
}